interface IconMoneyDSProps {
  width?: number;
  height?: number;
  className?: string;
}

const IconMoneyDS = ({ width = 56, height = 56, className }: IconMoneyDSProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 56 56"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.18799 22.4325C6.42878 22.4325 9.05597 19.8054 9.05597 16.5646H11.056C11.056 20.9099 7.53335 24.4325 3.18799 24.4325V22.4325Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.20929 36.9833C9.20929 33.7425 6.5821 31.1153 3.34131 31.1153V29.1153C7.68667 29.1153 11.2093 32.638 11.2093 36.9833H9.20929Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.9254 24.8146C40.6846 24.8146 38.0574 27.4417 38.0574 30.6825H36.0574C36.0574 26.3372 39.58 22.8146 43.9254 22.8146V24.8146Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M37.9041 10.5646C37.9041 13.8054 40.5312 16.4325 43.772 16.4325V18.4325C39.4267 18.4325 35.9041 14.9099 35.9041 10.5646H37.9041Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8657 18.8009C19.2045 19.2371 19.1254 19.8653 18.6892 20.204C17.6575 21.0051 16.7896 22.8203 16.7896 25.2706C16.7896 27.5351 17.6766 28.8359 18.7434 29.607C19.191 29.9306 19.2916 30.5557 18.968 31.0033C18.6445 31.4509 18.0193 31.5514 17.5717 31.2279C15.9709 30.0707 14.7896 28.1598 14.7896 25.2706C14.7896 22.4378 15.7832 19.9283 17.4626 18.6243C17.8988 18.2856 18.527 18.3646 18.8657 18.8009Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.2679 28.3655C27.9292 27.9293 28.0082 27.3011 28.4444 26.9623C29.4761 26.1613 30.3441 24.346 30.3441 21.8957C30.3441 19.6312 29.457 18.3305 28.3902 17.5593C27.9426 17.2358 27.842 16.6107 28.1656 16.1631C28.4891 15.7155 29.1143 15.6149 29.5619 15.9385C31.1627 17.0957 32.3441 19.0066 32.3441 21.8957C32.3441 24.7286 31.3504 27.2381 29.671 28.5421C29.2348 28.8808 28.6066 28.8017 28.2679 28.3655Z"
      fill="#228BE6"
    />
    <path
      d="M20.1907 27.3256C20.0766 27.2127 19.8256 26.7613 20.1907 26.1294C20.5558 25.4975 21.092 25.6442 21.2289 25.7457C21.6168 26.0053 22.3128 26.4905 23.1685 26.4905C23.7161 26.4905 24.1155 26.152 24.1155 25.678C24.1155 25.1138 23.6135 24.7414 22.7007 24.3126C21.3887 23.6693 20.0538 22.9471 20.0538 21.3221C20.0538 19.9793 21.1148 18.6251 23.2141 18.6251C24.6403 18.6251 25.7356 19.3473 26.1463 19.6407C26.306 19.731 26.2034 20.3629 25.9524 20.7015C25.7014 21.04 25.1993 21.3673 24.9255 21.2093C24.6175 20.9949 23.8074 20.4758 23.0772 20.4758C22.5068 20.4758 22.2444 20.8256 22.2444 21.2206C22.2444 21.672 22.7806 22.0218 23.739 22.4845C24.9483 23.0713 26.5 23.7258 26.5 25.5652C26.5 26.9645 25.2792 28.3638 23.2712 28.3638C21.4913 28.375 20.5101 27.6415 20.1907 27.3256Z"
      fill="#228BE6"
    />
    <path
      d="M22.4436 17.8116C22.4436 17.3634 22.8069 17.0001 23.2551 17.0001C23.7032 17.0001 24.0666 17.3634 24.0666 17.8116V19.4386C24.0666 19.8868 23.7032 20.2501 23.2551 20.2501C22.8069 20.2501 22.4436 19.8868 22.4436 19.4386V17.8116Z"
      fill="#228BE6"
    />
    <path
      d="M22.4436 27.5616C22.4436 27.1134 22.8069 26.7501 23.2551 26.7501C23.7032 26.7501 24.0666 27.1134 24.0666 27.5616V29.1886C24.0666 29.6368 23.7032 30.0001 23.2551 30.0001C22.8069 30.0001 22.4436 29.6368 22.4436 29.1886V27.5616Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.9875 30.5039C34.6123 29.6931 39.4142 29.2751 42 29.0947V11.0026C40.4581 11.0244 37.8474 11.1983 34.0191 11.8866C31.9822 12.2528 29.5553 12.9466 26.607 13.7894L26.4109 13.8454C23.4126 14.7024 19.9605 15.6821 16.0974 16.5181C11.7816 17.452 7.41485 17.8373 5 17.9906V35.9945C6.59668 35.9618 9.30101 35.7719 13.2189 35.0626C17.3026 34.3234 29.4728 30.9206 30.6961 30.5773L31.2365 32.5029C30.0697 32.8304 17.7778 36.2699 13.5751 37.0307C8.45939 37.9567 5.30042 38.03 3.88205 37.9927C3.37643 37.9794 3 37.5617 3 37.056V17.0614C3 16.5195 3.42805 16.0744 3.96925 16.0467C5.99407 15.943 10.8833 15.6001 15.6743 14.5633C19.5803 13.7181 23.0654 12.7217 26.1293 11.8458C29.0152 11.0208 31.5273 10.3026 33.6651 9.91819C38.7122 9.01074 41.7661 8.96238 43.1381 9.01416C43.6352 9.03293 44 9.4456 44 9.94308V30.0222C44 30.5563 43.5824 30.997 43.0494 31.0299C40.8646 31.1648 35.3705 31.5729 31.424 32.4557C31.3577 32.4705 31.3019 32.4846 31.2365 32.5029L30.6961 30.5773C30.7964 30.5492 30.8869 30.5264 30.9875 30.5039Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.402 14.0001C46.642 14 46.8664 14.0022 47.0674 14.0056C48.1632 14.0242 49 14.9246 49 15.9847V34.3446C49 35.4131 48.1639 36.2849 47.1104 36.3507C44.9995 36.4825 39.9002 36.8689 36.2613 37.6847C36.2123 37.6957 36.1731 37.7056 36.1248 37.7192C35.0124 38.0323 23.289 41.3235 19.2379 42.059C14.3614 42.9445 11.3007 43.0286 9.85812 42.9939C8.76589 42.9676 8 42.0624 8 41.0589V39.9104C8 39.3581 8.44772 38.9104 9 38.9104C9.55228 38.9104 10 39.3581 10 39.9104V40.9965C11.3406 41.0219 14.2386 40.9341 18.8806 40.0912C22.8125 39.3773 34.4139 36.123 35.5829 35.794C35.6658 35.7707 35.7398 35.752 35.8238 35.7331C39.6353 34.8787 44.8796 34.486 46.9858 34.3546C46.9893 34.3544 46.9909 34.3537 46.992 34.3532C46.9937 34.3524 46.9957 34.351 46.9975 34.3491C46.9993 34.3472 47 34.3458 47 34.3456C47 34.3456 47 34.3455 47 34.3456C47 34.3459 47 34.3458 47 34.3446V16.0048C46.818 16.0019 46.6169 16 46.4031 16.0001C45.8508 16.0004 45.4028 15.553 45.4025 15.0007C45.4022 14.4484 45.8497 14.0004 46.402 14.0001Z"
      fill="#228BE6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M51.402 19.0001C51.642 19 51.8664 19.0022 52.0674 19.0056C53.1632 19.0242 54 19.9246 54 20.9847V39.3446C54 40.4131 53.1639 41.2849 52.1104 41.3507C49.9995 41.4824 44.9002 41.8689 41.2613 42.6847C41.2123 42.6957 41.1731 42.7056 41.1248 42.7192C40.0124 43.0323 28.289 46.3235 24.2379 47.059C19.3614 47.9445 16.3007 48.0286 14.8581 47.9939C13.7659 47.9676 13 47.0624 13 46.0589V44.9104C13 44.3581 13.4477 43.9104 14 43.9104C14.5523 43.9104 15 44.3581 15 44.9104V45.9965C16.3406 46.0219 19.2386 45.9341 23.8806 45.0912C27.8125 44.3773 39.4139 41.123 40.5829 40.794C40.6658 40.7707 40.7398 40.752 40.8238 40.7331C44.6353 39.8787 49.8796 39.486 51.9858 39.3546C51.9893 39.3544 51.9909 39.3537 51.992 39.3532C51.9937 39.3524 51.9957 39.351 51.9975 39.3491C51.9993 39.3472 52 39.3458 52 39.3456C52 39.3456 52 39.3455 52 39.3456C52 39.3459 52 39.3458 52 39.3446V21.0048C51.818 21.0019 51.6169 21 51.4031 21.0001C50.8508 21.0004 50.4028 20.553 50.4025 20.0007C50.4022 19.4484 50.8497 19.0004 51.402 19.0001Z"
      fill="#228BE6"
    />
  </svg>
);

export default IconMoneyDS;
